// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import SolomonIslands from '../_raw/flag/icon_flag_solomon_islands.png';

export default () => <img src={SolomonIslands} alt="SolomonIslands" />;
